export default {
};



// WEBPACK FOOTER //
// ./src/store/auth/auth.getters.js